<template>
  <!-- Estado vacío: el proyecto tiene pictogramas pero no hay diseño de parque. -->
  <div class="absolute flex items-center w-full" style="top: 50%; left: 50%; transform: translate(-50%, -50%);">
    <div style="width: 480px; padding: 30px 0 8px; margin: 0 auto; color: #0a131c">
      <h3 class="font-light text-center text-4xl">Sin parque fotovoltaico</h3>
      <p class="text-center text-sm mt-2.5 mx-0 mb-9">El proyecto tiene pictogramas asociados a actividades pero no cuenta con el diseño.</p>
      <div class="text-center mt-6" style="color: #76767D">
        <b-icon icon="ban" pack="fas" custom-size="fa-5x"></b-icon>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ViewerEmptyDesign",
}
</script>
